import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Tooltip,
  Avatar,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { logoutUser } from "../redux/slices/LoginSlice";
import { store } from "../redux/store";

const Navbar = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { loadingLogout, loadingLogoutSuccess } = useSelector(
    (state) => state.LoginSlice
  );
  const { profileDetails } = useSelector((state) => state.ProfileSlice);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeSnackbar = () => setSnackbarOpen(false);

  const logout = () => {
    dispatch(logoutUser());
  };

  useEffect(() => {
    if (loadingLogoutSuccess) {
      store.dispatch({ type: "auth/clearState" });
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      setSnackbarOpen(true);
      navigate("/");
    }
  }, [loadingLogoutSuccess, navigate]);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: "#1E3899",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Left Section (Logo + Title) */}
          <Box
            display="flex"
            alignItems="center"
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/agentSelection")}
          >
            <Avatar
              src={require("../assets/images/logo.png")}
              alt="Logo"
              sx={{ width: 40, height: 40, mr: 1 }}
            />
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: 600, letterSpacing: 0.5 }}
            >
              Extract IQ
            </Typography>
          </Box>

          {/* Right Section (Notification + Profile + Logout) */}
          <Box display="flex" alignItems="center" gap={2}>
            <Tooltip title="Notifications">
              <IconButton sx={{ color: "white" }}>
                <NotificationsIcon />
              </IconButton>
            </Tooltip>

            {/* <Tooltip title={`${profileDetails?.first_name ?? ""} ${profileDetails?.last_name ?? ""}`}>
              <Avatar
                alt="Profile"
                src={require("../assets/images/profile.png")}
                sx={{ width: 36, height: 36 }}
              />
            </Tooltip> */}

            <Tooltip title="Logout">
              <IconButton
                sx={{ color: "white" }}
                onClick={logout}
                disabled={loadingLogout}
              >
                {loadingLogout ? (
                  <CircularProgress size={22} sx={{ color: "white" }} />
                ) : (
                  <LogoutIcon />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Snackbar for Logout Success */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={closeSnackbar} severity="success" sx={{ width: "100%" }}>
          Logout successful!
        </Alert>
      </Snackbar>
    </>
  );
};

export default Navbar;
